import { AmpPlugin } from '../amp-plugin';
import { AmpEventsSources } from './amp-events-sources';
const AmpEventsSourcesPlugin = new AmpPlugin(AmpEventsSources);
export { AmpEventsSourcesPlugin }